import React from 'react';
import useStyles from '../styles';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { toast } from '@livable/saas-react-components';
import { Alert, Button, Typography } from '@mui/material';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
import { BackdropLoader } from '@livable/saas-react-components';
export const DeleteModalForm = observer(_ref => {
  let data = _ref.data,
    callback = _ref.callback,
    handleModalClose = _ref.handleModalClose;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const modalFooterClasses = useModalFooterStyles();
  const handleSubmit = async () => {
    try {
      const cData = {
        credentialsId: data.id,
        isHardDelete: true
      };
      const resp = await store.credentials.deleteCredentialAsync.run(cData);
      if (resp && resp.isSuccessful) {
        toast('success', {
          body: ['Successfully deleted']
        });
        await callback();
      }
      handleModalClose();
    } catch (error) {
      handleModalClose();
    }
  };
  return /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("div", {
    className: classes.modalBody
  }, /*#__PURE__*/React.createElement(Alert, {
    severity: "warning",
    icon: false,
    size: "small"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "Do you really want to delete the \"", data.name, "\" credential? This action will permanently delete all data from Pro."))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooterStandart
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: handleModalClose,
    'custom-attribute': '519-appfolio-page'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    onClick: handleSubmit,
    'custom-attribute': '520-appfolio-page'
  }, "Delete credential"))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.credentials.getGlAccountsAsync.inProgress || store.credentials.getCredentialsAsync.inProgress || store.credentials.postCredentialsAsync.inProgress || store.credentials.patchCredentialsAsync.inProgress || store.credentials.deleteCredentialAsync.inProgress || store.credentials.getCredentialsUsersAsync.inProgress || store.credentials.getCredentialsPropertiesAsync.inProgress || store.credentials.patchCredentialsPropertiesAsync.inProgress
  }));
});